/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: index.ts
 * Class: index.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { PaymentState } from './types';
import { RootState } from '../types';
import { getDefaultState } from '../utils';

export const state: PaymentState = {
  createPayment: { ...getDefaultState() },
  additionalPaymentDetails: { ...getDefaultState() },
  disableMethod: { ...getDefaultState() },
  verifyPayment: { ...getDefaultState() },
  getPayment: { ...getDefaultState() },
};

const namespaced = true;

export const payment: Module<PaymentState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
